/**
 * Internal Ops Console config.
 *
 * Unobvious same-origin path for the staff Ops Console. This is "unlisted", NOT a
 * security boundary — access is enforced server-side by withInternalAdmin
 * (WorkOS session + INTERNAL_ADMIN_EMAILS allowlist).
 */
export const OPS_CONSOLE_PATH = '/8f3a2c1b/ops-console';

/** Public asset (clients/web/public/jordan.jpg) — used across the console's exclusive UI. */
export const OPS_JORDAN_IMG = '/jordan.jpg';
